export default "__VITE_ASSET__Ca3mnKYy__"